<template>
  <div v-loading="loading">
    <div ref="tablePrint" class="print">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrint">
          <salesPersonTable :tabelTitel="tabelTitel" :listQuery="listQuery" :tabelList="tabelList"
            :sumsTotal="sumsTotal"></salesPersonTable>
        </div>
      </div>
    </div>
    <div ref="tablePrintExport" class="Export_table" v-show="false">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrintExport">
          <salesPersonTable :tabelTitel="tabelTitel" :listQuery="listQuery" :exportShow="true"
            :tabelList="tabelList" :sumsTotal="sumsTotal"></salesPersonTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
  </div>
</template>
<script>
  import DateUtils from '@/utils/DateUtils';
  import salesPersonTable from './salesPersonTable'
  // import {orderReportTotal} from '@/api/reportcenter/ReportTableDefinition'
  // import getLodop from '@/utils/LodopFuncs.js'
  import getLodop from '../../utils/Lodopfuncs'

  export default {
    components: {
      salesPersonTable
    },
    data() {
      return {
        listQuery: {
          shiftCode: '',
          userId: '',
          outletId: '',
          startTime:DateUtils.formatDate(new Date(), "yyyy-MM-dd"),
          endTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd ")
        },
        // employee: this.$store.state.user.employee,
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotelInfo: localStorage.getItem('hotel'),
        loading: false,
        listShift: [{
            code: 'order_num',
            chinese_desc: '单号'
          },
          {
            code: 'salesName',
            chinese_desc: '销售员'
          },
          {
            code: 'people_count',
            chinese_desc: '人数'
          },
          {
            code: 'avgPeoplePrice',
            chinese_desc: '人均'
          },
        ],
        listPush: [{
            code: 'tax',
            chinese_desc: '税'
          },
          {
            code: 'discount',
            chinese_desc: '折扣'
          },
          {
            code: 'server_price',
            chinese_desc: '服务费'
          },
          {
            code: 'unPayPrice',
            chinese_desc: '挂单/未结'
          },
          {
            code: 'all_price',
            chinese_desc: '合计'
          },
          {
            code: 'payPrice',
            chinese_desc: '付款'
          },
          {
            code: 'check_type',
            chinese_desc: '支付方式'
          },
          {
            code: 'link_num',
            chinese_desc: '联单号'
          },
        ],
        tabelTitel: [],
        tabelList: []
      }
    },
    created() {
      this.getInit()
      this.$bus.$on('todoQuery', this.getData)
      this.$bus.$on('todoPrintCatering', this.todoPrint)
      this.$bus.$on('todoExportCatering', this.todoExport)
    },
    beforeDestroy() {
      this.$bus.$off('todoQuery', this.getData);
      this.$bus.$off('todoPrintCatering', this.todoPrint)
      this.$bus.$off('todoExportCatering', this.todoExport)
    },
    computed: {
      sumsTotal: function () {
        let sums = []
        sums[this.tabelTitel.length - 1] = undefined
        this.tabelTitel.map((item, index) => {
          this.tabelList.map(sItem => {
            if (item.code == 'people_count') {
              if (!sums[index]) {
                sums[index] = 0
              }
              if (sItem[item.code]) {
                sums[index] = Number(sums[index]) + Number(sItem[item.code])
              }
              sums[index] = sums[index] + ''
            } else {
              if (item.code != 'check_type' && item.code != 'link_num') {
                sItem[item.code] = sItem[item.code] ? sItem[item.code] : 0
              }
              if (typeof (sItem[item.code]) == 'number') {
                if (!sums[index]) {
                  sums[index] = 0
                }
                sums[index] += sItem[item.code] ? sItem[item.code] : 0
              }
            }

          })
        })
        if (this.tabelTitel.length) {
          sums[0] = '合计'
        }
        return sums
      }
    },
    methods: {
      getData(val) {
        this.listQuery = Object.assign({}, val)
        this.getInit()
      },
      getInit() {
        let methods = "get"
        let url = this.api.orderTotal
        let data = this.listQuery
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status == 0) {
            this.tabelTitel = res.data.data && res.data.data.tabelTitel.length > 0 ? res.data.data.tabelTitel : []
            // 添加转房账和未接/挂账
            this.tabelTitel.push(...this.listPush)
            // 在第一条插入营业点
            this.tabelTitel.unshift(...this.listShift)
            let map = new Map();
            this.tabelList = res.data.data && res.data.data.orderTotal.length > 0 ? res.data.data.orderTotal : []
            let tabelListData = res.data.data && res.data.data.orderFoodTypeTotal.length > 0 ? res.data.data
              .orderFoodTypeTotal : []
            tabelListData.forEach(item => {
              if (map.has(item.order_num)) {
                map.get(item.order_num).push(item)
              } else {
                map.set(item.order_num, [item])
              }
            })
            map.forEach(item => {
              let find = this.tabelList.find(v => v.order_num == item[0].order_num)
              item.forEach(sub => {
                if (find) {
                  find[sub.code] = sub.total_price
                }
              })
            })
          }
        })
      },
      todoPrint(type) {
        const LODOP = getLodop()
        // 获取大小和宽度
        let printSize =  12
        let width = 2
        if (LODOP) {
          // 判断是否是数字
          let falg = false
          if (document.getElementById('tablePrint')) {
            document.getElementById("copy_div").innerHTML = ""
            let innerHTML = document.getElementById('tablePrint').cloneNode(true)
            innerHTML.style.border = 'none'
            innerHTML.style.borderCollapse = 'collapse'
            innerHTML.style.fontSize = printSize + 'px'
            document.getElementById("copy_div").appendChild(innerHTML);
            falg = true
          }
          this.$nextTick(() => {
            var strFormHtml = `
                <body >` +
              document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML +
              '</body>' //获取打印内容
            LODOP.PRINT_INIT('') //初始化
            LODOP.SET_PRINT_PAGESIZE(0, 0, 0, 'A4') //设置打印方向
            LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
            LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
            LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, '') //设置预览窗口模式和大小
            LODOP.ADD_PRINT_TEXT(566, 542, 165, 22, "第#页/共&页");
            LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
            LODOP.SET_PRINT_STYLEA(0, "Horient", 2);
            LODOP.SET_PRINT_STYLEA(0, "Vorient", 1);
            if (type === 'preview') {
              LODOP.PREVIEW();
            } else {
              LODOP.PRINT()
            }
          })

        }
      },
      todoExport() {
        const LODOP = getLodop()
        if (LODOP) {
          // 获取大小和宽度
          let width = 2
          var strFormHtml = '<body>' + document.getElementById('tablePrintExport').innerHTML + '</body>' //获取打印内容
          LODOP.PRINT_INIT('') //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') //设置纵向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
          LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
          LODOP.SAVE_TO_FILE("餐单消费明细表.xlsx");
        }
      }
    }
  }
</script>